import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from '../castleActivitySearch/index';
import CastleActivitySearchFilters from './components/castleActivitySearchFilters';
import { DataProvider } from '../../assignments/ExamAndAssignmentsContext';
import ExamsAndAssignments from '../../questionsSearch/pages/examsAndAssignments';
import VocabularyId from './components/vocabularyId';

const CastleActivitySearchRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />}>
        <Route index element={<Navigate to="vocabularies" />} />
        <Route path="/vocabularies" element={<CastleActivitySearchFilters />} />
        <Route path="/exams_assignments/:activityType?" element={<DataProvider><ExamsAndAssignments /></DataProvider>} />
        <Route path="vocabularyId" element={<VocabularyId />} />
      </Route>
    </Routes>
  );
};

export default CastleActivitySearchRoute;